import { render, staticRenderFns } from "./MinistriesMens.vue?vue&type=template&id=21bd4be8&"
import script from "./MinistriesMens.vue?vue&type=script&lang=js&"
export * from "./MinistriesMens.vue?vue&type=script&lang=js&"
import style0 from "./MinistriesMens.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports